import { useEffect, useMemo, useState } from 'react';

/**
 * @param {string} query
 * @returns {boolean}
 */
export function useMediaQuery(query) {
  const mediaQueryList = useMemo(() => window.matchMedia(query), [query]);
  const [matches, setMatches] = useState(mediaQueryList.matches);

  useEffect(() => {
    const controller = new AbortController();
    mediaQueryList.addEventListener(
      'change',
      (event) => {
        setMatches(event.matches);
      },
      { signal: controller.signal }
    );

    return () => {
      controller.abort();
    };
  }, [mediaQueryList]);

  return matches;
}
